import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-background/10 rounded-sm flex items-center justify-center">
                <Play className="w-5 h-5 fill-current" />
              </div>
              <span className="font-serif text-xl font-semibold">
                Tower Lakes Chapel
              </span>
            </Link>
            <p className="text-background/70 text-sm leading-relaxed">
              Sharing God's word through worship services, Bible studies, and special messages. 
              Access our media library anytime.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg font-semibold">Media Categories</h4>
            <nav className="flex flex-col gap-2">
              <Link 
                to="/?category=sunday-service" 
                className="text-background/70 hover:text-background text-sm transition-colors"
              >
                Sunday Services
              </Link>
              <Link 
                to="/?category=bible-study" 
                className="text-background/70 hover:text-background text-sm transition-colors"
              >
                Bible Studies
              </Link>
              <Link 
                to="/?category=special-events" 
                className="text-background/70 hover:text-background text-sm transition-colors"
              >
                Special Events
              </Link>
              <Link 
                to="/?category=youth-ministry" 
                className="text-background/70 hover:text-background text-sm transition-colors"
              >
                Youth Ministry
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg font-semibold">Contact Us</h4>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-center gap-3 text-background/70">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span>Tower Lakes, Illinois</span>
              </div>
              <div className="flex items-center gap-3 text-background/70">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>(555) 123-4567</span>
              </div>
              <div className="flex items-center gap-3 text-background/70">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>info@towerlakeschapel.org</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background/10 text-center text-sm text-background/50">
          <p>&copy; {new Date().getFullYear()} Tower Lakes Chapel. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
